// src/components/Loader.jsx
import React from "react";
import "../styles/loader.scss";

function Loader({ size = "20px", color = "#fff" }) {
  return (
    <div
      className="loader"
      style={{
        width: size,
        height: size,
        borderColor: `${color} transparent transparent transparent`,
      }}
    />
  );
}

export default Loader;
